/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digital_KeyInputs */

const en_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Key`)
};

const es_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave digital`)
};

const fr_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé numérique`)
};

const de_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitaler Schlüssel`)
};

const ja_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタルキー`)
};

const zh_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字密钥`)
};

const ar_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المفتاح الرقمي`)
};

const id_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci Digital`)
};

const it_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave Digitale`)
};

const ru_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровой ключ`)
};

const pt_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave Digital`)
};

const ko_digital_key = /** @type {(inputs: Digital_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 키`)
};

/**
* | output |
* | --- |
* | "Digital Key" |
*
* @param {Digital_KeyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const digital_key = /** @type {((inputs?: Digital_KeyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digital_KeyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_digital_key(inputs)
	if (locale === "es") return es_digital_key(inputs)
	if (locale === "fr") return fr_digital_key(inputs)
	if (locale === "de") return de_digital_key(inputs)
	if (locale === "ja") return ja_digital_key(inputs)
	if (locale === "zh") return zh_digital_key(inputs)
	if (locale === "ar") return ar_digital_key(inputs)
	if (locale === "id") return id_digital_key(inputs)
	if (locale === "it") return it_digital_key(inputs)
	if (locale === "ru") return ru_digital_key(inputs)
	if (locale === "pt") return pt_digital_key(inputs)
	return ko_digital_key(inputs)
});